import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

// Register Chart.js components
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
);

const TicketTypeChart = ({ ticket_types }: any) => {
    const labels = ticket_types?.map((ticket: any) => ticket?.type_name);
    const dataCounts = ticket_types?.map((ticket: any) => ticket?.count);

    const data = {
        labels,
        datasets: [
            {
                label: 'Tickets',
                data: dataCounts,
                backgroundColor: [
                    '#FBBF24',
                    '#F472B6',
                    '#3B82F6',
                    '#6366F1',
                    '#8B5CF6',
                ],
                borderRadius: 8,
                borderSkipped: false,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
            },
        },
        scales: {
            x: {
                grid: {
                    display: false, 
                },
                ticks: {
                    maxRotation: 45,
                    minRotation: 45, 
                },
            },
            y: {
                beginAtZero: true,
                grid: {
                    color: '#bbb9b9',
                },
                ticks: {
                    stepSize: 5,
                    
                },
            },
        },
    };

    return (
        <div className="p-2 border-border border rounded-lg shadow-md">
            <h3 className="text-lg font-semibold mb-4">Ticket Type</h3>
            <Bar data={data} options={options} />
        </div>
    );
};

export default TicketTypeChart;
